//state
export var ideologiaState = {
  ideologias: [],
  ideologia: {},
  status_ideologia: ""
};

//getters
export var ideologiaGetters = {
  //funciones para optener informacion del state
  getIdeologias: state => state.ideologias
};

//actions
export var ideologiaActions = {
  async getIdeologias({ commit }) {
    commit("ideologia_request");
    await this._vm.$http
      .get("/apache/rest_api/apache.ideology", {
        headers: {
          fields: '["id","name", "reach_estimate",("state_id",["id", "name"]),["zip_ids", ["id", "name"]]]'
          //"X-Odoo-dbfilter": "apachev1",
        }
      })
      .then(res => {
        var ideologias = res.data;
        commit("ideologia_success", ideologias);
        return res;
      })
      .catch(err => {
        commit("ideologia_error");
        return err;
      });
  },
  async newIdeology({ commit, state }, ideologia) {
    commit("ideologia_request");
    var { name,
      state_id,
      state_selected,
      zip_ids,
      zips } = ideologia;
    var formData = new FormData();
    var newIdeology = `{
      'name':'${name}',
      "state_id":'${state_id}',
      'zip_ids': [${zip_ids}],
      'relational_fields': [('zip_ids', 'res.country.state.zip')],
    }`;
    formData.append("data", newIdeology);
    await this._vm.$http
      .post("/apache/rest_api/apache.ideology", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        }
      })
      .then(res => {
        if (res.status == 201) {
          ideologia.id = res.data.id;
          ideologia.state_id = state_selected;
          ideologia.zip_ids = zips;
          ideologias.push(ideologia);
          commit("ideologia_success", ideologias);
          return codPostales;
        } else {
          commit("ideologia_error");
        }
      })
      .catch(err => {
        commit("ideologia_error");
        return err;
      });
  },
  async editIdeology({ commit, state }, ideologia) {
    commit("ideologia_request");
    var { 
      id,
      name,
      state_id,
      state_selected,
      zip_ids,
      zips 
    } = ideologia;
    var formData = new FormData();
    var newIdeology = `{
      'name':'${name}',
      "state_id":'${state_id}',
      'zip_ids': [${zip_ids}],
      'relational_fields': [('zip_ids', 'res.country.state.zip')],
    }`;
    formData.append("data", newIdeology);
    await this._vm.$http
      .put("/apache/rest_api/apache.ideology", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        },
        params: {
          ids: `[${id}]`
        }
      })
      .then(res => {
        if (res.status == 200) {
          ideologia.id = res.data.id;
          ideologia.state_id = state_selected;
          ideologia.zip_ids = zips;
          var ideologias = state.ideologias
          for (var i = 0; i < ideologias.length; i++) {
            if (ideologias[i].id == id) {
              index = i;
              ideologias[i] = ideologia;
              break;
            }
          }
          ideologias.splice(index, 1);
          ideologias.splice(index, 0, ideologia);
          commit("ideologia_success", ideologias);
          return codPostales;
        } else {
          commit("ideologia_error");
        }
      })
      .catch(err => {
        commit("ideologia_error");
        return err;
      });
  },
  async deleteIdeologiaAction({ commit, state }, id) {
    commit("ideologia_request");
    try {
      await this._vm.$http
        .delete(`/apache/rest_api/apache.ideology/${id}`, {
          headers: {
            "X-Odoo-dbfilter": "apachev1"
          }
        })
        .then(res => {
          if (res.status == 210) {
            var index;
            var ideologias = state.ideologias;
            for (var i = 0; i < ideologias.length; i++) {
              if (ideologias[i].id == id) {
                index = i;
                break;
              }
            }
            ideologias.splice(index, 1);
            commit("ideologia_success", ideologias);

            return ideologias;
          } else {
            commit("ideologia_error");
          }
        })
        .catch(err => {
          commit("ideologia_error");
          return err;
        });
    } catch (error) {
      console.log(error);
    }
  },
  async deleteIdeologiaUtility({ commit, state }, id) {
    commit("ideologia_request");
    var index;
    var ideologias = state.ideologias;
    for (var i = 0; i < ideologias.length; i++) {
      if (ideologias[i].id == id) {
        index = i;
        break;
      }
    }
    ideologias.splice(index, 1);
    commit("ideologia_success", ideologias);

    return ideologias;
  }
};

//mutations

export var ideologiaMutations = {
  ideologia_request(state) {
    state.status_ideologia = "loading";
  },
  ideologia_success(state, payload) {
    state.status_ideologia = "success";
    state.ideologias = payload;
  },
  ideologia_error(state) {
    state.status_ideologia = "error";
  }
};
